import { createContext, useContext, useEffect, useId } from 'react';

type DialogOpenedContext = {
  numberOfOpenedDialogs: number;
  isDialogOpen: boolean;
  dispatchOpenEvent: (dialogId: string) => void;
  dispatchCloseEvent: (dialogId: string) => void;
};

export const DialogOpenedContext = createContext<DialogOpenedContext | null>(
  null
);

export const useDialogOpenedContext = () => useContext(DialogOpenedContext)!;

export const useUpdateOpenDialogContext = (open: boolean) => {
  const { dispatchOpenEvent, dispatchCloseEvent } = useDialogOpenedContext();
  const id = useId();

  useEffect(() => {
    if (open) {
      dispatchOpenEvent(id);
    } else {
      dispatchCloseEvent(id);
    }

    return () => {
      if (open) {
        dispatchCloseEvent(id);
      }
    };
  }, [dispatchCloseEvent, dispatchOpenEvent, id, open]);
};
